import { MenuProps } from 'antd';
import React from 'react';

import { ReactComponent as PersonIcon } from 'assets/icons/PersonFill.svg';
import { ContactPopover } from 'layouts/Component/ContactPopover';
import { GlossairePopover } from 'layouts/Component/GlossairePopover';
import { NotificationPopover } from 'layouts/Component/NotificationPopover';
import { AccessType } from 'types/User';

export type MenuItem = Required<MenuProps>['items'][number];

export const topNavigationItems = [
  {
    key: '/actualites',
    label: 'Actualités',
  },
  {
    key: '/calculer-prime',
    label: 'Calculer une prime',
    allowedForAccessType: [AccessType.SIMULATEUR],
  },
  {
    key: '/nouveau-dossier-concessionnaire',
    label: 'Demande de prime',
    allowedForAccessType: [AccessType.CONCESSIONNAIRE],
  },
  {
    key: '/tableau-des-primes',
    label: 'Tableau des primes',
    allowedForAccessType: [AccessType.CONCESSIONNAIRE],
  },
  {
    key: '/soumettre-dossier',
    label: 'Soumission de dossier',
    allowedForAccessType: [AccessType.CLIENT],
  },
  {
    key: '/dossiers',
    label: 'Suivi des dossiers',
  },
  {
    key: '/documents',
    label: 'Documents',
    allowedForAccessType: [AccessType.SIMULATEUR],
  },
  {
    key: '/faq',
    label: 'FAQ',
  },
  {
    key: '/glossaire',
    icon: <GlossairePopover />,
  },
  {
    key: 'contact',
    icon: <ContactPopover />,
  },
  {
    key: 'userAccount',
    icon: <PersonIcon />,
    children: [
      {
        key: '/mon-compte',
        label: 'Mon compte',
      },
      {
        key: 'logout',
        label: 'Déconnexion',
      },
    ],
  },
  {
    key: 'notifications',
    icon: <NotificationPopover />,
  },
];

export const bottomNavigationItems = [
  {
    key: '/actualites',
    label: 'Actualités',
  },
  {
    key: '/calculer-prime',
    label: 'Calculer une prime',
    allowedForAccessType: [AccessType.SIMULATEUR],
  },
  {
    key: '/nouveau-dossier-concessionnaire',
    label: 'Demande de prime',
    allowedForAccessType: [AccessType.CONCESSIONNAIRE],
  },
  {
    key: '/tableau-des-primes',
    label: 'Tableau des primes',
    allowedForAccessType: [AccessType.CONCESSIONNAIRE],
  },
  {
    key: '/soumettre-dossier',
    label: 'Soumission de dossier',
    allowedForAccessType: [AccessType.CLIENT],
  },
  {
    key: '/dossiers',
    label: 'Suivi des dossiers',
  },
  {
    key: 'https://www.ecologie.gouv.fr/dispositif-des-certificats-deconomies-denergie',
    label: 'Réglementation',
    target: '_blank',
  },
  {
    key: '/faq',
    label: 'FAQ',
  },
  {
    key: 'https://www.hellio.com/mentions-legales',
    label: 'Mentions légales',
  },
  {
    key: 'https://www.hellio.com/cgu',
    label: "Conditions générales d'utilisation",
  },
  {
    key: 'https://www.hellio.com/politique-confidentialite',
    label: 'Politique de confidentialité',
  },
  {
    key: '/documents',
    label: 'Documents',
    allowedForAccessType: [AccessType.SIMULATEUR],
  },
];

export default topNavigationItems;
